<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: { type: String, default: '#000000' },
  label: { type: String, default: '' },
});
const emit = defineEmits(['update:modelValue']);

const HEX_RE = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

// Generate unique ID for label association
const fieldId = `brand-color-${Math.random().toString(36).slice(2, 9)}`;

const onColorInput = event => emit('update:modelValue', event.target.value);

const onHexInput = event => {
  const value = event.target.value.trim();
  if (HEX_RE.test(value)) emit('update:modelValue', value.toLowerCase());
};

const previewStyle = computed(() => ({ backgroundColor: props.modelValue }));
</script>

<template>
  <div class="flex flex-col gap-1">
    <label v-if="label" :for="fieldId" class="text-sm text-n-slate-11">
      {{ label }}
    </label>
    <div class="flex items-center gap-2">
      <input
        type="color"
        class="w-10 h-10 p-0 border rounded cursor-pointer border-n-weak"
        :value="modelValue"
        :aria-label="label || 'color'"
        @input="onColorInput"
      />
      <input
        :id="fieldId"
        data-testid="hex-input"
        type="text"
        class="w-28 px-2 py-1 text-sm uppercase border rounded border-n-weak"
        :value="modelValue"
        @input="onHexInput"
      />
      <span
        data-testid="color-preview"
        class="inline-block w-8 h-8 border rounded border-n-weak"
        :style="previewStyle"
      />
    </div>
  </div>
</template>
